<template>
    <div id="homepage">

        <!-- About -->
        <section class="content-section bg-light">
          <div class="container text-center">
            <div class="row">
              <div class="col-lg-10 mx-auto">
                <h2>{{$t("e_main_kibigo_is")}}<vue-typer
                :text='[$t("e_main_kibigo_adj"), $t("e_main_kibigo_adj2"), $t("e_main_kibigo_adj3"), $t("e_main_kibigo_adj4"), $t("e_main_kibigo_adj5")]'
                :repeat='Infinity'
                :shuffle='true'
                initial-action='typing'
                :pre-type-delay='100'
                :type-delay='50'
                :pre-erase-delay='2000'
                :erase-delay='70'
                erase-style='backspace'
                :erase-on-complete='false'
                caret-animation='phase'
                ></vue-typer></h2>
                <p class="lead m-5">{{$t("e_main_des")}}</p>
              </div>
            </div>
          </div>
        </section>

        <!-- Services -->
        <section class="content-section-small text-white text-center" style="background-color: #f0932b;">
          <div class="container text-left">
            <div class="content-section-heading">
              <h3 class="text-primary mb-0">{{$t("e_step_wow_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("e_step_wow_title")}}</h2>
              <p class="lead">{{$t("e_step_wow_des")}}
              </p>
            </div>
          </div>
        </section>


        <section class="content-section-small bg-light">
          <div class="container text-right">
            <div class="content-section-heading">
              <h3 class="text-primary mb-0">{{$t("e_step_bone_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("e_step_bone_title")}}</h2>
              <p class="lead mb-5">{{$t("e_step_bone_des")}}</p>
            </div>
          </div>
        </section>

        <!-- Services -->
        <section class="content-section-small text-white text-center" id="services" style="background-color: #f0932b;">
          <div class="container text-left">
            <div class="content-section-heading">
              <h3 class="text-primary mb-0">{{$t("e_step_shape_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("e_step_shape_title")}}</h2>
              <p class="lead mb-5">{{$t("e_step_shape_des")}}</p>

            </div>
          </div>
        </section>


        <section class="content-section-small bg-light">
          <div class="container text-right">
            <div class="content-section-heading">
              <h3 class="text-primary mb-0">{{$t("e_step_pack_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("e_step_pack_title")}}</h2>
              <p class="lead mb-5">{{$t("e_step_pack_des")}}</p>
            </div>
          </div>
        </section>

        <!-- Portfolio -->
        <section class="content-section" id="portfolio">
          <div class="container">
            <div class="content-section-heading text-center">
              <h3 class="text-secondary mb-0">{{$t("e_courses_pretitle")}}</h3>
              <h2 class="mb-5">{{$t("e_courses_title")}}</h2>
            </div>
        
            <div class="row no-gutters">
              <div class="col-lg-6">
                <router-link :to="{ name: 'ContactUs'}">
                <a class="portfolio-item" href="">
                  <span class="caption">
                    <span class="caption-content">
                      <h1> {{$t("e_courses_ai_title")}}</h1>
                      <p class="mb-0">{{$t("e_courses_ai_des")}}</p>
                    </span>
                  </span>
                  <img class="img-fluid" src="../assets/portfolio-1.jpg" alt="">
                </a>
                </router-link>
              </div>
              <div class="col-lg-6">
                <router-link :to="{ name: 'ContactUs'}">
                <a class="portfolio-item" href="">
                  <span class="caption">
                    <span class="caption-content">
                      <h1> {{$t("e_courses_social_title")}}</h1>
                      <p class="mb-0">{{$t("e_courses_social_des")}}</p>
                    </span>
                  </span>
                  <img class="img-fluid" src="../assets/portfolio-2.jpg" alt="">
                </a>
                </router-link>
              </div>
              <div class="col-lg-6">
                <router-link :to="{ name: 'ContactUs'}">
                <a class="portfolio-item" href="">
                  <span class="caption">
                    <span class="caption-content">
                      <h1>{{$t("e_courses_design_title")}}</h1>
                      <p class="mb-0">{{$t("e_courses_design_des")}}</p>
                    </span>
                  </span>
                  <img class="img-fluid" src="../assets/portfolio-3.jpg" alt="">
                </a>
                </router-link>
              </div>
              <div class="col-lg-6">
                <router-link :to="{ name: 'ContactUs'}">
                <a class="portfolio-item" href="">
                  <span class="caption">
                    <span class="caption-content">
                      <h1>{{$t("e_courses_app_title")}}</h1>
                      <p class="mb-0">{{$t("e_courses_app_des")}}</p>
                    </span>
                  </span>
                  <img class="img-fluid" src="../assets/portfolio-4.jpg" alt="">
                </a>
                </router-link>
              </div>
            </div>
          </div>
        </section>






    </div>

</template>

<script>
import {firebase, database, storage} from "@/firebase";
export default {
    name: 'Mission',
    data () {
        return {
            featured: [],
            third: {}
        }
    },
    created () {
        database.collection("Projects").where("isFeatured", "==", true)
        .get()
        .then(querySnapshot => {
            let index = 0;
            querySnapshot.forEach(element => {
                storage.child("Projects/"+ element.id + "/profilo").getDownloadURL().then(url => {
                    if(index <= 2){
                        index++;
                        this.featured.push({...element.data(), id: element.id, image: url})
                    } else
                    this.third = { ...element.data(), id: element.id, image: url || "http://placehold.it/1920x1080"}
                    })
                });
            });
    },
}

</script>

<style scoped>

.business-header {
    height: 50vh;
    min-height: 350px;
    background: #303030;
    background: urlcenter scroll;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
}

#partecipanti img {
    padding: 5px;
    margin: 5px;
    width: 150px;
    height: 100%;
}

.textall{
    color: #303030;
}

.texto {
    color: #f0932b;
}

.sottotexto{
    color: #f0932b;
    margin-top: 18%;
    font-size: 23px;
}

.subtexto{
    color: #777777;
    margin-top: -15px;
}

.titler {
    color: #f0932b;
    font-weight: bold;
}

.buttora {
    color: rgb(71, 71, 71);
    background-color: #f0932b;
}

.logos{
    height: 150px;
    weight: 150px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.logo2{
    height: 363px;
    weight: 800px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.parallax {
  background-color: #2c3e50;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}




</style>



// WEBPACK FOOTER //
// src/components/Mission.vue